/* eslint-disable import/prefer-default-export */
// Internal Imports
import { isCellEditable, setClassName } from "./methods";
import { GRID } from "../constants";

// Destructuring
const { DEALTABLE_COLUMNS } = GRID;

/**
 * @param {string} name - Field name, say (sku, product name, etc).
 * @param {object} obj - Holds the column properties.
 */
export const generateBasedOnName = (name, object) => {
  const obj = object;
  switch (name) {
    case DEALTABLE_COLUMNS.PRODUCT_NAME:
      obj.pinned = "left";
      obj.lockPosition = true;
      return obj;
    case DEALTABLE_COLUMNS.PRODUCT_CODE:
      obj.pinned = "left";
      obj.lockPosition = true;
      return obj;
    case DEALTABLE_COLUMNS.DISC_PERCENT:
    case DEALTABLE_COLUMNS.ADDITIONAL_DISCOUNT_PERCENT:
      obj.minWidth = 131;
      obj.props.range = { min: 0, max: 100 };
      return obj;
    case DEALTABLE_COLUMNS.QUANTITY:
      obj.cellClass = setClassName;
      obj.cellRenderer = "PriceMatrixRenderer";
      obj.editable = isCellEditable;
      obj.props.range = { min: 1, max: 10000000 };
      return obj;
    case DEALTABLE_COLUMNS.PRICE: // Points to Base Price
      obj.cellClass = setClassName;
      obj.editable = isCellEditable;
      obj.cellRenderer = "PriceMatrixDepedencyRenderer";
      return obj;
    case DEALTABLE_COLUMNS.EXT_BASE_PRICE:
      obj.cellClass = setClassName;
      obj.editable = isCellEditable;
      obj.props.range = { min: 1, max: 10000000 };
      return obj;
    case DEALTABLE_COLUMNS.SELLING_TERM:
      obj.cellClass = setClassName;
      obj.editable = isCellEditable;
      obj.props.range = { min: 1, max: 10000000 };
      return obj;
    case DEALTABLE_COLUMNS.BILLING_FREQUENCY:
      obj.cellClass = setClassName;
      obj.editable = isCellEditable;
      return obj;
    case DEALTABLE_COLUMNS.SKU_QUANTITY:
      obj.cellClass = setClassName;
      obj.editable = isCellEditable;
      obj.props.range = { min: 1, max: 10000000 };
      return obj;
    case DEALTABLE_COLUMNS.DISCOUNTED_PRICE:
      obj.minWidth = 85;
      return obj;
    case DEALTABLE_COLUMNS.PRODUCT_DESC:
      obj.minWidth = 95;
      return obj;
    default:
      return obj;
  }
};
